import type { Transformer } from "@/Common/Models/Domain/Transformer";
import type { UserApi } from "@/Modules/Models/Api/User";
import type { User } from "@/Modules/Models/Domain/User";

import UserTransformer from "./User";

class UserApiToUserTransformer implements Transformer<UserApi, User> {
  public transform(userApi: UserApi): User {
    return UserTransformer.toDomain(userApi);
  }
}

export default UserApiToUserTransformer;
